export default __webpack_public_path__ + "static/media/dailyAvailability.a0760202.svg";